// extracted by mini-css-extract-plugin
module.exports = {"root":"tptnJrDx","title":"_QtZf62L"};